// extracted by mini-css-extract-plugin
export default {"block":"StatBlock_block__R323I","value":"StatBlock_value__wE8v9","label":"StatBlock_label__2eh4A","gradient":"StatBlock_gradient__Utikk","light":"StatBlock_light__thhWC"};